import { api } from './api';
import { API_ENDPOINTS } from './endpoints';

export const customerService = {
  getAll: (params?: any) => 
    api.get(API_ENDPOINTS.CUSTOMERS.INDEX, { params }),

  getById: (id: number | string) => 
    api.get(API_ENDPOINTS.CUSTOMERS.SHOW(id)),

  create: (data: any) => 
    api.post(API_ENDPOINTS.CUSTOMERS.STORE, data),

  update: (id: number | string, data: any) => 
    api.put(API_ENDPOINTS.CUSTOMERS.UPDATE(id), data),

  getOrders: (id: number | string, params?: any) => 
    api.get(API_ENDPOINTS.CUSTOMERS.ORDERS(id), { params }),

  getProducts: (id: number | string, params?: any) => 
    api.get(API_ENDPOINTS.CUSTOMERS.PRODUCTS(id), { params }),

  getPendingCosts: (id: number | string) => 
    api.get(API_ENDPOINTS.CUSTOMERS.PENDING_COSTS(id)),

  payProduct: (id: number | string, productId: number | string, data: { paidout_at: string | null; cost_ids?: number[] }) => 
    api.patch(API_ENDPOINTS.CUSTOMERS.PAY_PRODUCT(id, productId), data),

  addMaintenanceCost: (id: number | string, productId: number | string, data: any) => 
    api.post(API_ENDPOINTS.CUSTOMERS.MAINTENANCE_COSTS(id, productId), data),

  deleteMaintenanceCost: (id: number | string, productId: number | string, costId: number | string) => 
    api.delete(API_ENDPOINTS.CUSTOMERS.MAINTENANCE_COST(id, productId, costId)),

  getReferrals: (id: number | string) => 
    api.get(API_ENDPOINTS.CUSTOMERS.REFERRALS(id)),

  addReferral: (id: number | string, referredUserId: number) => 
    api.post(API_ENDPOINTS.CUSTOMERS.ADD_REFERRAL(id), { referred_user_id: referredUserId }),

  removeReferral: (id: number | string, referredId: number | string, params?: { action?: 'delete' | 'unlink' }) => 
    api.delete(API_ENDPOINTS.CUSTOMERS.REMOVE_REFERRAL(id, referredId), { params }),

  getReferralProducts: (id: number | string, referredId: number | string, params?: any) =>
    api.get(API_ENDPOINTS.CUSTOMERS.REFERRAL_PRODUCTS(id, referredId), { params }),

  updateReferralDates: (id: number | string, referredId: number | string, data: { started_at?: string | null; ended_at?: string | null }) =>
    api.put(API_ENDPOINTS.CUSTOMERS.UPDATE_REFERRAL_DATES(id, referredId), data),
};
